export default function initContextMenu($) {
  'use strict';

  const toggle = '[data-toggle="context"]';

  class ContextMenu {
    constructor(element, options = {}) {
      this.$element = $(element);

      this.before = options.before || this.before;
      this.onItem = options.onItem || this.onItem;
      this.scopes = options.scopes || null;
      this.openDirection = options.openDirection || 'auto';

      if (options.target) {
        this.$element.data('target', options.target);
      }

      this.listen();
    }

    show(e) {
      if (this.isDisabled()) return;

      this.closemenu();

      if (this.before.call(this, e, $(e.currentTarget)) === false) return;

      const $menu = this.getMenu();

      // ⚠️ Se não achou o menu, sai sem tentar criar listeners
      if (!$menu || !$menu.length) {
        // eslint-disable-next-line no-console
        console.warn('ContextMenu: não encontrou o elemento de menu para', this.$element);
        return false;
      }

      const relatedTarget = { relatedTarget: this, target: e.currentTarget };

      $menu.trigger($.Event('show.bs.context', relatedTarget));

      const tp = this.getPosition(e, $menu);
      const items = 'li:not(.divider)';

      $menu
        .attr('style', '')
        .css(tp)
        .addClass('open')
        .on(
          'click.context.data-api',
          items,
          $.proxy(this.onItem, this, $(e.currentTarget))
        )
        // Removed mousewheel listener via jQuery
        .trigger('shown.bs.context', relatedTarget);

      // ✅ Add native passive mousewheel listener to avoid DevTools warning
      this._stopWheel = (e) => e.stopPropagation();
      $menu[0].addEventListener('mousewheel', this._stopWheel, {
        passive: true,
      });

      $('html').on(
        'click.context.data-api mousewheel.context.data-api',
        $menu.selector,
        $.proxy(this.closemenu, this)
      );

      return false;
    }

    closemenu(e) {
      const $menu = this.getMenu();

      if (!$menu.hasClass('open')) return;

      const relatedTarget = { relatedTarget: this };
      const items = 'li:not(.divider)';

      $menu
        .trigger($.Event('hide.bs.context', relatedTarget))
        .removeClass('open')
        .off('click.context.data-api', items)
        .trigger('hidden.bs.context', relatedTarget);

      // ✅ Remove native mousewheel listener if it was added
      if (this._stopWheel) {
        $menu[0].removeEventListener('mousewheel', this._stopWheel, {
          passive: true,
        });
        this._stopWheel = null;
      }

      $('html').off('click.context.data-api', $menu.selector);

      if (e) e.stopPropagation();
    }

    keydown(e) {
      if (e.which === 27) this.closemenu(e);
    }

    before() {
      return true;
    }

    onItem() {
      return true;
    }

    listen() {
      this.$element.on(
        'contextmenu.context.data-api',
        this.scopes,
        $.proxy(this.show, this)
      );
      $('html').on('click.context.data-api', $.proxy(this.closemenu, this));
      $('html').on('keydown.context.data-api', $.proxy(this.keydown, this));
    }

    destroy() {
      this.$element.off('.context.data-api').removeData('context');
      $('html').off('.context.data-api');
    }

    isDisabled() {
      return (
        this.$element.hasClass('disabled') || this.$element.attr('disabled')
      );
    }

    getMenu() {
      let selector = this.$element.data('target');

      if (!selector) {
        selector = this.$element.attr('href');
        selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '');
      }

      const $menu = $(selector);
      return $menu.length ? $menu : this.$element.find(selector);
    }

    getPosition(e, $menu) {
      const mouseX = e.clientX;
      const mouseY = e.clientY;
      const boundsX = $(window).width();
      const boundsY = $(window).height();
      const menuWidth = $menu.find('.dropdown-menu').outerWidth();
      const menuHeight = $menu.find('.dropdown-menu').outerHeight();
      const tp = { position: 'fixed', 'z-index': 9999 };

      const Y =
        this.openDirection === 'up' ||
        (mouseY + menuHeight > boundsY && this.openDirection !== 'down')
          ? { top: Math.max(mouseY - menuHeight, 0) }
          : { top: mouseY };

      const X =
        mouseX + menuWidth > boundsX && mouseX - menuWidth > 0
          ? { left: mouseX - menuWidth + $(window).scrollLeft() }
          : { left: mouseX + $(window).scrollLeft() };

      return $.extend(tp, Y, X);
    }
  }

  $.fn.contextmenu = function (option, e) {
    return this.each(function () {
      const $this = $(this);
      let data = $this.data('context');
      const options = typeof option === 'object' && option;

      if (!data)
        $this.data('context', (data = new ContextMenu($this, options)));
      if (typeof option === 'string') data[option].call(data, e);
    });
  };

  $.fn.contextmenu.Constructor = ContextMenu;

  $(document)
    .on('contextmenu.context.data-api', function () {
      $(toggle).each(function () {
        const data = $(this).data('context');
        if (!data) return;
        data.closemenu();
      });
    })
    .on('contextmenu.context.data-api', toggle, function (e) {
      $(this).contextmenu('show', e);
      e.preventDefault();
      e.stopPropagation();
    });
}
